/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-closing-tag-location */
import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import Radium from 'radium';
import { Radio } from '@lyearn-team/frontend-components';
import Icon from '../../../../helper/Icon';

let styles = {};

@Radium
class SingleChoiceResponse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      response: this.props.submission.response
    };
  }

  UNSAFE_componentWillMount() {
    if (
      this.props.response
      && this.props.response.toString() !== '-1'
      && !this.props.actualSubmit
    ) {
      this.setState({
        response: this.props.response
      });
    } else {
      this.setState({
        response: this.props.submission.response
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.response && nextProps.response.toString() !== '-1' && !this.props.actualSubmit) {
      this.state.response = nextProps.response;
    } else {
      this.state.response = nextProps.submission.response;
    }
  }

  @autobind
  optionPressed(index) {
    if (
      this.props.submission.evaluatedAnswer !== ''
      && this.props.actualSubmit
      && this.props.subType === 'survey'
    ) {
      return;
    }
    let response = index.toString();
    response === this.state.response && (response = '');
    this.setState({ response });
    this.props.uploadResponse(response, '', false);
  }

  renderChoices = () => this.props.options.map((option, index) => {
    const selected = parseInt(this.state.response, 10) === index;
    let evaluatedAnswer = this.props.submission.evaluatedAnswer !== '' && this.props.actualSubmit;
    const disabled = evaluatedAnswer && this.props.subType === 'survey';
    if (this.props.subType === 'survey') {
      evaluatedAnswer = null;
    }
    const trueButNotSelected = evaluatedAnswer && !selected && option.correct;
    let evaluatedWrapper = null;
    let evaluatedText = null;
    if (evaluatedAnswer) {
      if (option.correct) {
        evaluatedWrapper = styles.evaluatedWrapperTrue;
        evaluatedText = styles.evaluatedTextTrue;
      } else if (selected) {
        evaluatedWrapper = styles.evaluatedWrapperFalse;
        evaluatedText = styles.evaluatedTextFalse;
      }
    }
    const optionView = (
      <div
        style={[
          evaluatedAnswer ? styles.evaluatedOptionWrapper : styles.optionWrapper,
          selected ? styles.selectedWrapper : null,
          evaluatedWrapper,
          trueButNotSelected ? styles.trueButNotSelectedWrapper : null
        ]}
        key={index}
      >
        <div
          style={[
            styles.direction,
            styles.optionText,
            selected ? styles.selectedText : null,
            evaluatedText,
            { alignItems: 'center' }
          ]}
        >
          <div style={styles.checkboxTextContainer}>
            <Radio
              disabled={disabled}
              checked={selected}
              style={{ width: '24px' }}
              labelStyle={{ display: 'none' }}
              onChange={evaluatedAnswer ? () => {} : () => this.optionPressed(index)}
            />
            <span
              dangerouslySetInnerHTML={{
                __html: option.text
              }}
            />
          </div>
          {evaluatedAnswer ? (
            option.correct ? (
              <Icon
                icon="check"
                style={styles.IconSize}
                size="1.8em"
                fill={styles.IconCorrectColor}
              />
            ) : selected ? (
              <Icon
                icon="close"
                style={styles.IconSize}
                size="1.8em"
                fill={styles.IconIncorrectColor}
              />
            ) : null
          ) : null}
        </div>
      </div>
    );

    if (evaluatedAnswer) {
      return (
        <div style={styles.bottomMargin}>
          <div>{optionView}</div>
          <div style={styles.line} />
        </div>
      );
    }
    return (
      <div style={styles.bottomMargin}>
        <div>{optionView}</div>
        <div style={styles.line} />
      </div>
    );
  });

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.scrollViewStyle}>{this.renderChoices()}</div>
      </div>
    );
  }
}

styles = {
  container: {
    alignSelf: 'stretch',
    flex: 1
  },
  scrollViewStyle: {
    borderTop: '1px solid rgba(0,0,0,0.1)',
    borderRight: '1px solid rgba(0,0,0,0.1)',
    borderLeft: '1px solid rgba(0,0,0,0.1)',
    flex: 1,
    fontFamily: 'ProximaNova'
  },
  bottomMargin: {},
  direction: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  evaluatedOptionWrapper: {
    backgroundColor: 'white'
  },
  optionWrapper: {
    backgroundColor: 'white',
    ':hover': {
      backgroundColor: '#F3F5F7'
    }
  },
  IconCorrectColor: '#0aaf79',
  IconIncorrectColor: '#d63c3d',
  IconSize: {
    width: 20,
    height: 20,
    flexShrink: '0',
    marginLeft: '10px'
  },
  line: {
    borderBottom: 'solid 1px rgba(0,0,0,0.1)'
  },
  selectedWrapper: {},
  evaluatedWrapperTrue: {},
  trueButNotSelectedWrapper: {
    border: 'solid 2px #00cd8b',
    borderRadius: '1px',
    margin: '-1px'
  },
  evaluatedWrapperFalse: {},
  optionText: {
    fontSize: '14px',
    color: '#000000',
    paddingLeft: 24,
    paddingTop: 14,
    paddingBottom: 14,
    paddingRight: 24,
    minHeight: '19px'
  },
  selectedText: {},
  evaluatedTextTrue: {
    color: '#0baf79'
  },
  evaluatedTextFalse: {
    color: '#d63c3d'
  },
  checkboxTextContainer: {
    float: 'left',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    lineHeight: '19px'
  },
  hoveredWrapper: {
    backgroundColor: '#F3F5F7'
  }
};

module.exports = SingleChoiceResponse;
